<template>
  <b-modal
    :visible="show"
    title="Resultado da importação"
    @hide="$emit('close')"
    centered
    size="lg"
    hide-footer
  >

    <div class="text-center mb-4">
      <div class="mb-2">
        <i 
          class="fas fa-check-circle text-success"
          style="font-size: 45px;"
          v-if="!hasErrors"
        ></i>

        <i 
          class="fas fa-exclamation-triangle text-warning"
          style="font-size: 45px;"
          v-else
        ></i>
      </div>

      <h4 :class="hasErrors ? 'text-warning' : 'text-success'">
        {{ hasErrors ? 'Importação concluída com alguns erros' : 'Importação concluída com sucesso!' }}
      </h4>

      <p class="mb-0">
        Registros processados:
        <strong>{{ data.quantity_ok }}</strong>
      </p>

      <p v-if="hasErrors" class="mb-0 text-danger">
        Registros com erro:
        <strong>{{ data.quantity_invalid }}</strong>
      </p>
    </div>


    <div v-if="hasErrors">

      <h5 class="mb-3">
        Detalhes dos registros inválidos
      </h5>

      <b-table
        :items="data.invalid_data"
        :fields="fields"
        small
        striped
        responsive
        :per-page="perPage"
        :current-page="currentPage"
      >
        <template #cell(document)="data">
          {{ data.item.document }}
        </template>
      </b-table>

      <b-pagination
        v-if="data.invalid_data.length > perPage"
        v-model="currentPage"
        :total-rows="data.invalid_data.length"
        :per-page="perPage"
        align="center"
        size="sm"
        class="mt-3"
      />

    </div>

    <div class="text-right mt-3">
      <b-button variant="primary" @click="$emit('close')">
        Fechar
      </b-button>
    </div>
  </b-modal>
</template>
<script>
import { BModal, BTable, BButton, BPagination  } from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BTable,
    BButton,
    BPagination 
  },

  computed: {
    hasErrors() {
      return this.data.invalid_data && this.data.invalid_data.length > 0
    }
  },

  props: {
    show: Boolean,
    data: {
    type: Object,
    default: () => ({
        quantity_ok: 0,
        quantity_invalid: 0,
        invalid_data: []
    })
    }
  },
  

  data() {
    return {
      currentPage: 1,
      perPage: 5,
      fields: [
        { key: 'line', label: 'Linha' },
        { key: 'type', label: 'Tipo' },
        { key: 'document', label: 'Documento' },
        { key: 'name', label: 'Nome' },
        { key: 'reason', label: 'Motivo' },
        { key: 'source', label: 'Erro' }
      ]
    }
  }
}
</script>